import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RedirectCodeGuard implements CanActivate {
  private router = inject(Router);


  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const code = route.paramMap.get('code');

    if (!code) {
      this.router.navigate(['/404']);
      return of(false);
    }

    const destination = new URL(`https://shop.usto.re/sh/${encodeURIComponent(code)}`);

    const params = new URLSearchParams();
    Object.entries(route.queryParams ?? {}).forEach(([key, value]) => {
      if (value === null || value === undefined) return;
      params.set(key, String(value));
    });

    const queryString = params.toString();
    if (queryString) destination.search = queryString;

    window.location.replace(destination.toString());
    return of(false);
  }
}

